var map = {
	"./arrow.svg": 9609,
	"./b.svg": 5070,
	"./chanel.svg": 6353,
	"./close.svg": 7544,
	"./enter.svg": 4398,
	"./home-logo.svg": 8241,
	"./in.svg": 3235,
	"./logo.svg": 6475,
	"./mask.svg": 5324,
	"./menu.svg": 3627,
	"./next.svg": 7137,
	"./prev.svg": 7517,
	"./search.svg": 2752,
	"./zoom.svg": 2383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6933;